import { axiosInstance } from "../axios";
import { AllRsaKeys, RequestResponse } from "../types";

export const getRsaKeys: (
  page: number,
  size: number,
  issuerCode?: string,
  status?: string
) => Promise<
  RequestResponse<{ records: AllRsaKeys[]; total: number }>
> = async (page, size, issuerCode, status) => {
  try {
    const params: any = {
      page,
      size,
    };

    if (issuerCode) {
      params.issuerCode = issuerCode;
    }

    if (status) {
      params.status = status;
    }

    const response = await axiosInstance.get(`/rsa-key/get-keys`, {
      params,
    });

    return {
      error: false,
      data: {
        total: response.data.count,
        records: response.data.content,
      },
    };
  } catch (err: any) {
    console.error("Unable to fetch RSA keys: ", err);
    return {
      error: true,
      data: null,
      message: err.response?.data?.responseMessage || err.message,
    };
  }
};
